import React                     from 'react';
import { WithStyle }             from 'rewire-ui';
import Button                    from '@material-ui/core/Button';
import Icon                      from '@material-ui/core/Icon';
import { Theme }                 from '@material-ui/core/styles';
import SelectEmployeeDialog      from '../batch/SelectEmployeeDialog';
import selectEmployeeDialogModel from '../batch/SelectEmployeeDialogModel';
import RoutedEntityListView      from '../ui/RoutedEntityListView';
import SummaryListCardView       from './SummaryListCardView';
import summaryListModel          from './SummaryListModel';
import { withStyles }            from '../utility/styles';
import { ISearchResult }         from '../DataTypes';

const styles = (theme: Theme) => ({
  header: {
    width: '100%',
    padding: '0px',
  },
  button: {
    textTransform: 'none',
    flexShrink: 0,
    width: '100%',
    marginBottom: '7px',
  },
  icon: {
    marginRight: '10px'
  },
  addIcon: {
    color: theme.palette.success.main,
  },
});

interface ISummaryListProps {
  classes?: any;
  className?: string;
}

type SummaryListProps = WithStyle<ReturnType<typeof styles>, ISummaryListProps>;

class SummaryListView extends React.PureComponent<SummaryListProps> {
  constructor(props: SummaryListProps) {
    super(props);
  }

  handleAddTimecard = () => {
    selectEmployeeDialogModel.load(async (selectedEmployee: ISearchResult) => {
      await summaryListModel.addTimecardForEmployee(selectedEmployee);
    });
  };

  renderSummaryListHeader = () => {
    const { classes } = this.props;
    return (
      <div className={classes.header}>
        <SelectEmployeeDialog />
        <Button onClick={this.handleAddTimecard} className={classes.button} variant='contained' type='submit' disabled={summaryListModel.viewOnly}>
          <Icon className='add'>{'add'}</Icon>
          <span>Add Timecard for Employee...</span>
        </Button>
      </div>
    );
  };

  render() {
    return (
      <RoutedEntityListView model={summaryListModel} ListHeader={this.renderSummaryListHeader} cardViewRenderer={SummaryListCardView} />
    );
  }
}

export default withStyles<ISummaryListProps>(styles, SummaryListView);
